export class Utils {
    static deepCopyArray(array: any)
    {
        return array ? JSON.parse(JSON.stringify(array)) : null;
    }
    static extractSQLError(message: string): string | null {
        const regex = /<SQLError>(.*?)<\/SQLError>/;
        const match = message.match(regex);
        return match ? match[1] : message;
    }
}